import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const fields = {
  _id: '',
  fireDistrict: '',
  millage: '',
  originalTaxDistrict: '',
  taxDistrictWithFire: '',
  isItSaForTulsa: '',
};

export const assessorFireTaxXRefActions = {
  async loadAssessorFireTaxXRefRecords({ commit, dispatch }, {
    baseCrudKey, criteria, postProcessTrans,
  }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql` query assessorFireTaxXRef($criteria: assessorFireTaxXRefCriteriaType) {
          assessorFireTaxXRef(criteria: $criteria) {
            ${fieldsToGqlString(fields)},
            }
          }`,
        variables: { criteria },
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      if (results.data) {
        const { assessorFireTaxXRef } = results.data;
        const processedTransData = postProcessTrans
          ? postProcessTrans(assessorFireTaxXRef) : assessorFireTaxXRef;
        commit('base/crud/setItems', [baseCrudKey, processedTransData], { root: true });
      }
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem getting List.', { root: true });
    }
  },
  async upsertAssessorFireTaxXRef({ dispatch, rootGetters, commit }, { item, baseCrudKey }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation upsertAssessorFireTaxXRef($item: assessorFireTaxXRefInputType!)  {
          upsertAssessorFireTaxXRef(upsert: $item) {
            ${fieldsToGqlString(fields)},
          }
        }`,
        variables: {
          item,
        },
      });
      clients.handleGQLErrors(results, commit);
      const taxData = rootGetters['base/crud/items'](baseCrudKey);
      const newTaxUnit = results.data.upsertAssessorFireTaxXRef;
      const newList = mergeByIdNewAtTop(taxData || [], newTaxUnit);
      commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem in upserting the assessor fire tax x-ref List', { root: true });
    }
  },
  async deleteAssessorFireTaxXRef({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation deleteAssessorFireTaxXRef ($id: ID!)  {
          deleteAssessorFireTaxXRef(id: $id) {
                _id
              }
            }`,
        variables: {
          id: item._id,
        },
      });
      clients.handleGQLErrors(results, commit);
      const delId = results.data.deleteAssessorFireTaxXRef._id;
      const taxData = rootGetters['base/crud/items'](baseCrudKey);
      const updatedData = taxData.filter((d) => d._id !== delId);
      commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
      commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem deleting the assessor fire tax x-ref', { root: true });
    }
  },
};

export default assessorFireTaxXRefActions;
